const DepartmentComponent = () => import('@/views/department/DepartmentView')

export default [
    {
        path:'/DepartmentIndex',
        name:'DepartmentIndex',
        component:DepartmentComponent
    }
]